var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmarkCircle02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M14.6668 7.99999C14.6668 4.31809 11.6821 1.33332 8.00016 1.33332C4.31826 1.33332 1.3335 4.31809 1.3335 7.99999C1.3335 11.6819 4.31826 14.6667 8.00016 14.6667C11.6821 14.6667 14.6668 11.6819 14.6668 7.99999Z",
    fill: "#C6F26B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00012 0.833008C11.9582 0.833008 15.1671 4.04196 15.1671 8C15.1671 11.958 11.9582 15.167 8.00012 15.167C4.04208 15.167 0.83313 11.958 0.83313 8C0.83313 4.04196 4.04208 0.833008 8.00012 0.833008ZM8.00012 1.83301C4.59437 1.83301 1.83313 4.59424 1.83313 8C1.83313 11.4058 4.59437 14.167 8.00012 14.167C11.4059 14.167 14.1671 11.4058 14.1671 8C14.1671 4.59424 11.4059 1.83301 8.00012 1.83301ZM10.298 5.66211C10.4846 5.45855 10.8014 5.44524 11.005 5.63184C11.2082 5.81848 11.2218 6.13446 11.0353 6.33789L7.36829 10.3379C7.27615 10.4383 7.14711 10.497 7.01086 10.5C6.87456 10.5029 6.74301 10.4499 6.64661 10.3535L4.97961 8.68652C4.78468 8.49123 4.78446 8.17465 4.97961 7.97949C5.17477 7.78434 5.49136 7.78456 5.68665 7.97949L6.9845 9.27734L10.298 5.66211Z",
    fill: "#455525"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkCircle02);
export default __webpack_public_path__ + "static/media/checkmark-circle-02.e71409f4c0f5acc1487399bbeb272d07.svg";
export { ForwardRef as ReactComponent };